import React from 'react'
import IconWrapper, { IconProps } from './IconWrapper'

export const SteamIcon = (props: IconProps) => (
    <IconWrapper {...props}>
        <svg
            version="1.1"
            x="0px"
            y="0px"
            width="24px"
            height="24px"
            viewBox="0 0 24 24"
            enableBackground="new 0 0 24 24"
            xmlSpace="preserve"
            aria-hidden="true"
        >
            <path
                fill="currentColor"
                d="M11.98 1C6.194 1 1.45 5.463 1 11.135l5.906 2.442a3.1 3.1 0 0 1 1.93-.537l2.626-3.807v-.054a4.16 4.16 0 0 1 4.155-4.156 4.16 4.16 0 0 1 4.155 4.156 4.16 4.16 0 0 1-4.155 4.156l-.095-.002-3.745 2.673q.003.073.003.148c0 1.72-1.399 3.119-3.119 3.119a3.124 3.124 0 0 1-3.058-2.505L1.38 15.022c1.307 4.625 5.557 8.016 10.6 8.016 6.087 0 11.02-4.934 11.02-11.019C23 5.933 18.067 1 11.98 1"
            ></path>
            <path
                fill="currentColor"
                d="m7.905 17.72-1.353-.56c.24.5.654.918 1.205 1.148a2.343 2.343 0 0 0 3.061-1.262c.24-.576.242-1.212.004-1.79a2.33 2.33 0 0 0-2.99-1.296l1.399.578a1.723 1.723 0 1 1-1.326 3.182M18.386 9.179a2.77 2.77 0 0 0-2.77-2.769 2.77 2.77 0 0 0-2.768 2.769 2.77 2.77 0 0 0 2.769 2.769 2.77 2.77 0 0 0 2.769-2.77m-4.845-.005a2.08 2.08 0 1 1 4.16 0 2.08 2.08 0 0 1-4.16 0"
            ></path>
        </svg>
    </IconWrapper>
)
